import { render } from "./IconArrows.vue?vue&type=template&id=468a94b6&scoped=true"
import script from "./IconArrows.vue?vue&type=script&lang=js"
export * from "./IconArrows.vue?vue&type=script&lang=js"

import "./IconArrows.vue?vue&type=style&index=0&id=468a94b6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-468a94b6"]])

export default __exports__